import { ReactNode } from 'react';
import TelmeSEO, { TelmeSEOProps } from './TelmeSEO';
import Breadcrumb from './Breadcrumb';

interface PageLayoutProps {
  children: ReactNode;
  SEOConfig?: TelmeSEOProps;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  className?: string;
}

const maxWidthMap: Record<NonNullable<PageLayoutProps['maxWidth']>, string> = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl',
  full: 'max-w-full',
};

const PageLayout = ({ children, SEOConfig, maxWidth = 'xl', className }: PageLayoutProps) => (
  <>
    {SEOConfig && <TelmeSEO {...SEOConfig} />}
    <div className="flex flex-col items-center gap-4 mb-5 flex-grow pt-24 lg:pt-32">
      <div className={`w-full px-4 sm:px-6 lg:px-10 ${maxWidthMap[maxWidth]}`}>
        <Breadcrumb />
      </div>
      <div
        className={`w-full flex min-h-screen px-4 sm:px-6 lg:px-10 ${maxWidthMap[maxWidth]} ${className ?? ''}`}
      >
        {children}
      </div>
    </div>
  </>
);

export default PageLayout;
